import {useEffect, useRef, useState} from "react";
import {NavLink} from "react-router-dom";

import {API_BASE_URL} from "../config.js";
import {SingleSelect} from "./Input.jsx";
import defaultAvatar from "../assets/images/default-avatar.png"

const THEME_OPTIONS = ["Light", "Dark", "System"];
const getSystemTheme = () => window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";

export default function Header({session}) {
    const [isOpen, setIsOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const [themePref, setThemePrefState] = useState(() => localStorage.getItem("theme") || "system");
    const [systemTheme, setSystemTheme] = useState(getSystemTheme());
    const dropdownRef = useRef(null);

    const theme = themePref === "system" ? systemTheme : themePref;

    const options = [
        {"label": "API keys", "to": "/keys"},
        {"label": "Documentation", "to": "/docs"},
        {"label": "Jobs", "to": "/jobs"},
        {"label": "Sign out", "to": "/logout"}
    ];

    const handleToggleMenu = () => setIsOpen(prev => !prev);

    const handleClickOutside = (event) => {
        if(dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsOpen(false);
        };
    };

    const handleMenuBlur = (event) => {
        if(!event.currentTarget.contains(event.relatedTarget)) {
            setIsOpen(false);
        };
    };

    const handleScroll = () => {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        setScrolled(scrollTop > 0);
    };

    const handleLogin = () => {
        window.location.href = `${API_BASE_URL}/auth/login`;
    };

    const setTheme = (value) => {
        localStorage.setItem("theme", value);
        setThemePrefState(value);
    };

    const handleThemeChange = (option) => {
        if(option) setTheme(option.toLowerCase());
    };

    useEffect(() => {
        document.documentElement.setAttribute("data-theme", theme);
        document.documentElement.style.colorScheme = theme;
    }, [theme]);

    useEffect(() => {
        const mql = window.matchMedia("(prefers-color-scheme: dark)");
        const handleSystemChange = (event) => setSystemTheme(event.matches ? "dark" : "light");

        mql.addEventListener("change", handleSystemChange);
        return () => mql.removeEventListener("change", handleSystemChange);
    }, []);

    useEffect(() => {
        document.addEventListener("pointerdown", handleClickOutside);
        return () => {
            document.removeEventListener("pointerdown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        document.addEventListener("scroll", handleScroll);
        return () => {
            document.removeEventListener("scroll", handleScroll);
        };
    }, []);

    return (
        <header className={`header ${scrolled ? "shadow" : ""}`}>
            <NavLink className="" to="/" tabIndex={0}>
                DTU QCloud
            </NavLink>

            <div className="end">
                {!session ? (
                    <button type="button" className="button" onClick={handleLogin} tabIndex={0}>Sign in</button>
                ) : (
                    <div className="usermenu" ref={dropdownRef} onBlur={handleMenuBlur}>
                        <button type="button" className="menu-toggle" onClick={handleToggleMenu} aria-label="Account menu" aria-expanded={isOpen} tabIndex={0}>
                            <img src={session.userinfo?.picture || defaultAvatar} alt="" className="avatar"/>
                        </button>

                        {isOpen && (
                            <div className="menu-dropdown">
                                <div className="menu-account">
                                    <img src={session.userinfo?.picture || defaultAvatar} alt="" className="menu-account-avatar"/>
                                    <span className="menu-account-name">{session.userinfo?.name || "N/A"}</span>
                                </div>
                                <div className="menu-divider"/>
                                <div className="menu-row">
                                    <span>Theme</span>
                                    <SingleSelect value={THEME_OPTIONS.find(o => o.toLowerCase() === themePref) || null} label="Theme" placeholder="Select theme" options={THEME_OPTIONS} onChange={handleThemeChange}/>
                                </div>
                                <div className="menu-divider"/>
                                {options.map(opt => (
                                    <NavLink key={opt.label} to={opt.to} className="option" onClick={() => setIsOpen(false)} tabIndex={0}>{opt.label}</NavLink>
                                ))}
                            </div>
                        )}
                    </div>
                )}
            </div>
        </header>
    );
};
